import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedCloudWatchApp from "./EmbeddedCloudWatchApp";
const CloudWatchApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "AWS Integrations" }, /* @__PURE__ */ React.createElement("span", null, "This feature retrieves log messages from various AWS sources.")), /* @__PURE__ */ React.createElement(EmbeddedCloudWatchApp, null));
export default CloudWatchApp;
